import { makeStyles } from '@mui/styles';
import { Colors } from '../../../utils/color';

export default makeStyles((theme) => ({
  report_container: {
    width: 'calc(100% - 25%)',
    height: 'calc(100% - 100px)',
    backgroundColor: theme.palette.background,
    // padding: '20px 18px 0px 18px',
    paddingTop: 20,
    paddingBottom: 0,
    paddingRight: '12.5%',
    paddingLeft: '12.5%',
    overflow: 'auto',
    // display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('xl')]: {
      paddingRight: '15%',
      paddingLeft: '15%',
      width: 'calc(100% - 30%)',
      // overflow: 'auto',
    },
    [theme.breakpoints.down('lg')]: {
      padding: '20px 18px 0px 18px',
      width: 'calc(100% - 20px)',
      // overflow: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px 18px 0px 18px',
      width: 'calc(100% - 36px)',
      // overflow: 'auto',
    },
  },
  toolbar_title: {
    display: 'inline-block',
    paddingTop: 15,
    fontSize: 24,
    fontWeight: 300,
    color: theme.palette.title_text,
  },
  properties_container: {
    paddingTop: 30,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 5,
    },
  },
  report_details: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    // justifyContent: 'space-between',
    // gap: 50,
    flex: 1,
    borderBottom: `1px solid ${theme.palette.background_border}`,
    marginBottom: 15,
    paddingBottom: 15,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  report_property_container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 50%',
      paddingTop: 25,
    },
    marginRight: 15,
  },
  reports_actions_container: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    gap: 10,
  },
  action_button: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.background_button}`,
    color: theme.palette.background_button,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    padding: '10px 25px',
    height: 40,
  },
  new_media_container: {
    alignItems: 'center',
    display: 'flex',
    gap: 5,
    cursor: 'pointer',
  },
  text_dark_blue: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: 12,
    color: theme.palette.background_button,
    cursor: 'pointer',
  },
  text_common: {
    color: theme.palette.profile_title,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
  },
  information_common_title: {
    color: theme.palette.profile_title,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      width: '66%',
    },
  },
  report_view_container: {
    // height: 'calc(100% - 127px)',
    // overflow: 'auto',
    // [theme.breakpoints.down('md')]: {
    //   height: 'auto',
    //   overflow: 'visible',
    // },
    paddingBottom: 5,
  },
  information_container: {
    padding: '0px 10px 0px 0',
    display: 'flex',
    flexDirection: 'column',
    // borderBottom: `1px solid ${theme.palette.background_border}`,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  information_data_container: {
    paddingTop: 15,
  },
  information_data_item_container: {
    padding: '16px 0 16px 34px',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${theme.palette.background_border}`,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    },
  },
  information_data_content_container: {
    width: 'calc(100% - 90px)',
    marginRight: 90,
    padding: '12px 0',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginRight: 0,
    },
  },
  information_title_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 0px 0px 0',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  information_data_title_container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
    marginBottom: 15,
  },
  flex_view: {
    display: 'flex',
    alignItems: 'center',
  },
  flex_column_view: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  information_title_sub_content: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      width: 'calc(100% - 35px)',
      paddingTop: 10,
      paddingLeft: 35,
    },
  },
  toggle_arrow: {
    width: 24,
    height: 24,
    cursor: 'pointer',
  },
  information_title: {
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.profile_title,
    marginLeft: 10,
    cursor: 'pointer',
  },
  issue_container: {
    backgroundColor: Colors.LIGHT_GREEN,
    // borderRadius: 40,
    padding: '10px 12px;',
    fontWeight: 400,
    fontSize: 14,
    color: Colors.WHITE,
    marginLeft: 16,
    width: 200,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: 'max-content',
    },
  },
  red_issue_container: {
    backgroundColor: Colors.TOMATO_RED,
    marginLeft: 16,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 8,
    },
  },
  issue_supply_box: {
    border: `1px solid ${theme.palette.background_border}`,
    borderRadius: 8,
    padding: 12,
    // marginTop: 8,
  },
  hide_border: {
    border: 'none',
  },
  flexView: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  no_data_message: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.background_button,
  },
  issue_supply_box_container: {
    display: 'flex',
    width: '100%',
    gap: 12,
    paddingTop: 15,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 8,
      paddingTop: 20,
    },
  },
  information_title_container1: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  report_elements_container: {
    display: 'flex',
    paddingLeft: 34,
    flexDirection: 'row',
    gap: 15,
    marginTop: 10,
    // paddingBottom: 10,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      flexWrap: 'wrap',
    },
  },
  report_elements_container1: {
    display: 'flex',
    paddingLeft: 34,
    flexDirection: 'row',
    gap: 15,
    paddingBottom: 10,
    paddingTop: 10,
    // borderBottom: `1px solid ${theme.palette.background_border}`,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 10,
      flexWrap: 'wrap',
    },
  },
  detail_section: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 10,
    // width: '60%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  media_section: {
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  issue_found_detail: {
    display: 'flex',
    flexDirection: 'row',
    gap: 15,
    marginTop: 10,
  },
  issue_found_list: {
    width: '40%',
    display: 'flex',
    marginBottom: 10,
    alignItems: 'center',
  },
  issue_found_desc: {
    width: '60%',
  },
  radio_view: {
    display: 'flex',
    flexDirection: 'row',
  },
  new_media: {
    display: 'flex',
    flexDirection: 'row',
    gap: 5,
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 10,
  },
  information_title_sub_content1: {
    width: 'auto',
    paddingLeft: 0,
  },
  options_text: {
    display: 'inline-block',
    marginBottom: 10,
  },
  radio_containerStyle: {
    alignItems: 'flex-start',
  },
  form_input: {
    '&::placeholder': {
      color: theme.palette.input_placeholder,
    },
    border: `1px solid ${theme.palette.input_border}`,
    backgroundColor: 'transparent',
    color: theme.palette.profile_title,
    '&:focus': {
      border: `1px solid ${theme.palette.input_border}`,
    },
  },
  checkboxContainer: {
    marginRight: 10,
  },
  checked_checkbox: {
    height: 20,
    width: 20,
  },
  list_checkbox: {
    height: 20,
    width: 20,
  },
  checkBoxMainContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 15,
    marginBottom: 10,
  },
  date_selector_container: {
    width: '90%',
  },
  related_issue_container: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.table_head_background,
    borderRadius: 5,
    marginBottom: 20,
  },
  related_issues: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${theme.palette.background_border}`,
    paddingBottom: 15,
    marginTop: 15,
  },

  // client report
  client_info_title_containeer: {
    display: 'flex',
    padding: 12,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background_button,
    // width: '90%',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: 'transparent',
      // padding: 0,
    },
  },
  client_information_title: {
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.background_button_text,
    // marginLeft: 10,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      color: theme.palette.profile_title,
      fontSize: 14,
    },
  },
  client_information_common_title: {
    color: theme.palette.profile_title,
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      width: '66%',
      fontSize: 14,
    },
  },
  client_info_sub_content_grp: {
    borderTop: `1px solid ${theme.palette.background_border}`,
  },
  client_info_sub_content: {
    display: 'flex',
    borderRight: `1px solid ${theme.palette.background_border}`,
    borderBottom: `1px solid ${theme.palette.background_border}`,
    borderLeft: `1px solid ${theme.palette.background_border}`,
    width: 'calc(100% - 2px)',
    flexDirection: 'column',
    marginBottom: 15,
    [theme.breakpoints.down('sm')]: {
      border: 'none',
      backgroundColor: theme.palette.background_border,
      padding: 12,
      borderRadius: 8,
      width: 'calc(100% - 24px)',
    },
  },
  client_report_elements_container: {
    display: 'flex',
    paddingLeft: 20,
    flexDirection: 'row',
    gap: 15,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    // paddingBottom: 10,
    // [theme.breakpoints.down('md')]: {
    //   paddingLeft: 0,
    //   flexWrap: 'wrap',
    // },
  },
  client_information_data_title_container: {
    width: '100%',
    display: 'flex',
    // alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `0.5px solid white`,
    // marginTop: 20,
    // marginBottom: 15,
  },
  client_detail_section: {
    display: 'flex',
    flexDirection: 'column',
    // paddingBottom: 10,
    // width: '60%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  client_issue_container: {
    backgroundColor: Colors.LIGHT_GREEN,
    // borderRadius: 40,
    padding: '10px 12px;',
    fontWeight: 400,
    fontSize: 14,
    color: Colors.WHITE,
    marginLeft: 16,
    width: 200,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: 80,
      padding: '5px 6px;',
      fontSize: 10,
    },
  },
  client_report_elements_container1: {
    display: 'flex',
    paddingLeft: 20,
    flexDirection: 'row',
    gap: 15,
    paddingBottom: 10,
    paddingTop: 10,
    // borderBottom: `1px solid ${theme.palette.background_border}`,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      flexWrap: 'wrap',
    },
  },
  client_notes_margin_btm: {
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 10,
    },
  },
  client_report_property_container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 50%',
      paddingTop: 0,
    },
    marginRight: 15,
  },
  margin_left_20: {
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  client_report_elements_container: {
    display: 'flex',
    paddingLeft: 20,
    flexDirection: 'row',
    gap: 15,
    // marginTop: 10,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      flexWrap: 'wrap',
      // marginTop: 5,
    },
  },
  detail_width: {
    width: '97%',
    [theme.breakpoints.down('sm')]: {
      width: '98%',
    },
  },
  issue_confirmed_container: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    gap: 10,
    marginRight: 5,
    marginTop: 2,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
}));
